import React, { useState, useEffect } from "react";
import Images from "../../commonComponents/Images/Images";
import DigidocUnique from "./DigidocUnique";
import WhyNeedDigidoc from "./WhyNeedDigidoc";
import CriticalFor from "./CriticalFor";
import Slider from "react-slick";
import HomeBanner from "./HomeBanner";
import DigidocFeatures from "./DigidocFeatures";
import ContactForm from "./ContactForm";
import BookADemoModal from "./BookADemoModal";
import { fa } from "intl-tel-input/i18n";
import { Link } from "react-router-dom";
import CurvedHeader from "../ComingSoon";

const HomePageComponents = () => {
  const [modalShow, setModalShow] = useState(false);
  const [demoModalShow, setDemoModalShow] = useState(false);
  const currentYear = new Date().getFullYear();
  // console.log("year", currentYear)

  const [activeSliderImages, setActiveSliderImages] = useState([]);

  const SliderImages = [
    {
      title: "Health Management made Simple",
      content:
        "Your patient's Medical Regimen Manager helping manage prescriptions, setting reminders for medications and home tests.",
      img: Images.slider1,
    },
    {
      title: "Trusted and ABDM Compliant",
      content:
        "DigiDoc integrates with national health records, making us reliable and ensuring security.",
      img: Images.slider2,
    },
    {
      title: "We Speak Your Language",
      content: "Access DigiDoc in your patient’s preferred language.",
      img: Images.slider3,
    },
    {
      title: "Stay Organized, Stay Healthy",
      content:
        "DigiDoc ensures your patients stay on track with their health, with minimal tech skills",
      img: Images.slider4,
    },
   
  ];

  const smallSliderImages = [
    {
      img: Images.smallSlider1,
    },
    {
      img: Images.smallSlider2,
    },
    {
      img: Images.smallSlider3,
    },
    {
      img: Images.smallSlider4,
    },
    
  ];

  useEffect(() => {
    const updateSliderImages = () => {
      if (window.innerWidth < 768) {
        setActiveSliderImages(smallSliderImages);
      } else {
        setActiveSliderImages(SliderImages);
      }
    };
    updateSliderImages();

    window.addEventListener("resize", updateSliderImages);

    return () => window.removeEventListener("resize", updateSliderImages);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
  };

  return (
    <>
      <div className="background-clr pb-0">
        {/* home banner section starts */}
        <HomeBanner />
        {/* home banner section ends */}

        <div className="background-Img">
          <div className="container">
            {/* slider starts */}
            <Slider {...settings}>
              {activeSliderImages.map((Images, index) => (
                <div key={index} className="slider-section ">
                  <div className="card">
                    <div className="img-div">
                      <img
                        src={Images.img}
                        alt={`slider ${index + 1}`}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            {/* slider ends */}

            {/* why digidoc section */}
            <section id="aboutUs">
              <div>
                <div className="pxy-80 why-digidoc-section">
                  <div className="row align-items-center py-20">
                    <h4 className="text-center">Why Digidoc?</h4>
                    <div className="col-lg-4 col-md-12 col-sm-12">
                      <div className="img-div my-20">
                        <img
                          src={Images.aboutUsImg}
                          alt="Digidoc"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-sm-12">
                      <p>
                       DigiDoc is built for ease of use, making it suitable even for users who are not tech-savvy. With support for multiple languages, the app allows users to manage their care in the language they are most comfortable with.{" "}
                      </p>
                      <p>
                     Simple navigation, clear instructions, and gentle reminders help users stay consistent without feeling overwhelmed. Backed by healthcare-grade security, DigiDoc delivers a reliable, accessible, and user-friendly care experience for everyone.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* why digidoc section ends*/}
          </div>
        </div>
      </div>
      {/* this is critical for section starts */}

      {/* <CriticalFor /> */}
      {/* this is critical for section ends */}

      <div className="background-clr">
        <div >
          {/* digidoc features section starts */}

          <DigidocFeatures />

          {/* digidoc features section ends */}

          {/* need digidoc section starts */}

          {/* <WhyNeedDigidoc /> */}

          {/* need digidoc section ends */}

          {/* digidoc unique section starts */}

          <DigidocUnique />

          {/* digidoc unique section ends */}

          {/* register now section */}
          {/* <div className="card registerNow-section mxy-40">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <div className="img-div">
                    <img
                      src={Images.registerNowImg}
                      alt="Register Now"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="col-lg-9 col-md-9 col-sm-12">
                  <h4 className="text-left">Register Now </h4>
                  <p className="text-left">
                    Be amongst the first to join the Digidoc community today!
                    Because... no cost for doctors, hospitals, or patients!
                  </p>
                  <div className="btn-div">
                    <button
                      class="btn btn-sm btn-yellow"
                      type="button"
                      onClick={() => setModalShow(true)}
                    >
                      Get in Touch
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div> */}
          {/* register now section ends*/}

          {/* footer section */}
   <section id="contactUs" className="bg-light">
      <div  >

        {/* ---------- Contact Header ---------- */}
        <div className="text-center mb-4">
          <h4 className="fw-bold">Contact Us</h4>
          <p className="text-muted text-center mb-0">
            We’re here to help! Fill out the form below, and our team will get back to you as soon as possible.
          </p>
        </div>

        {/* ---------- Contact Form ---------- */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-12">
            <ContactForm />
          </div>
        </div>

        {/* ---------- Curved Header ---------- */}
        <div className="my-4">
          <CurvedHeader />
        </div>



      </div>
    </section>
    <hr className="my-4" />

    {/* ---------- Footer Navigation ---------- */}
    <div className="footer-navigation py-3 justify-content-center px-5">
      <div className="row align-items-center  text-md-start">

        {/* Links */}
        <div className="col-12 col-md-10 mb-3 mb-md-0">
          <div className="d-flex flex-column flex-md-row gap-3 justify-content-center justify-content-md-start">
            <a href="#home" className="footer-link">Home</a>
            <a href="#aboutUs" className="footer-link">About Us</a>
            <a href="#digidocFeatures" className="footer-link">Features</a>
            <a href="#contactUs" className="footer-link">Contact Us</a>
            
            <Link
              to="/terms&conditions"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
             Terms & Conditions
            </Link>
                 <Link
              to="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Privacy Policy
            </Link>
          </div>
        </div>

        {/* Social Icons */}
        <div className="col-12 col-md-2">
          <div className="d-flex gap-3 justify-content-center justify-content-md-end">
            <a href="https://www.facebook.com/Digidochealth" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/digidochealth/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/digitivity-solutions/about/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.youtube.com/@DigiDoc.health" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
        </div>
        <hr />
        <div className="text-center">
         <span className="copyright-text">
  © {currentYear} DigiDoc. A product of{" "}
  <a
    href="https://digitivitysolutions.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="company-link"
  >
    Digitivity Solutions Pvt. Ltd.
  </a>
</span>
        </div>
        {/* footer section ends*/}
      </div>
      <BookADemoModal
        show={demoModalShow}
        onHide={() => setDemoModalShow(false)}
      />
    </>
  );
};
export default HomePageComponents;


